import api from "@/api";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

import landmarkIcon from "@/assets/icones/landmark-solid.svg";
import handshakeIcon from "@/assets/icones/handshake-simple-solid.svg";
import gearsIcon from "@/assets/icones/gears-solid.svg";
import sackDollarIcon from "@/assets/icones/sack-dollar-solid.svg";

export function useToolsPage() {
  const router = useRouter();
  const { locale } = useI18n();

  const searchAndNavigate = async (prefix) => {
    try {
      const currentLanguage =
      localStorage.getItem("selectedLanguage") || locale.value || "pt";
      const params = { nome: prefix, idioma: currentLanguage };
      const response = await api.searchTools(params);

      const ferramentas = response.data.filter(
        (tool) => tool.nome === prefix && tool.idioma === currentLanguage
      );

      const ferramenta = ferramentas.length > 0 ? ferramentas[0] : null;

      if (ferramenta && ferramenta.id) {
        router.push({
          name: "LevelZero",
          params: { id: ferramenta.id },
          state: { ferramenta: ferramenta },
        });
      } else {
        console.warn(
          `Ferramenta não encontrada com nome '${prefix}' e idioma '${currentLanguage}'.`
        );
      }
    } catch (error) {
      console.error("Erro ao buscar ferramenta:", error);
    }
  };

  return {
    searchAndNavigate,
    landmarkIcon,
    handshakeIcon,
    gearsIcon,
    sackDollarIcon,
  };
}
